import React from 'react';

const ComponentLoader = () => (
  <div className="component-loader-container">
    <div className="component-loader-inner">
      <div className="component-loader-spinner" />
      <p>Loading...</p>
    </div>
  </div>
);

export default ComponentLoader;


